<template>
  <div class="ccui-home-index">
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <el-search
        :formProp="formData"
        @search="search"
        :isShowSearch="true"
        :selectClear="true"
        class="ccui-highsearch no-print"
        :class="[
          languagezh_cn ? '' : 'languageen_us',
          'ccui-highsearch no-print'
        ]"
        :key="isFocus"
      >
        <anchorTitle
          isList
          :tabBtn="tableTopBtn"
          :isFocus="isFocus"
          :isShowNum="true"
          :totalNum="pageTotal"
          @tabBtnChange="tableTopChange"
        />
        <template slot="search">
          <!-- 方案编号 -->
          <el-input
            v-model.trim="formData.schemeCode"
            clearable
            :searchLabel="$t('page.content.schemeCode')"
            :placeholder="$t('page.content.schemeCodePlaceholder')"
          ></el-input>
          <!-- 标题 -->
          <el-input
            v-model.trim="formData.schemeName"
            clearable
            :searchLabel="$t('page.content.schemeName')"
            :placeholder="$t('page.content.schemeNamePlaceholder')"
          ></el-input>
          <!-- 标题 -->
          <el-input
            v-model.trim="formData.noticeTitle"
            clearable
            :searchLabel="$t('page.content.GGTitle')"
            :placeholder="$t('page.content.titlePlaceholder')"
          ></el-input>
          <!-- <el-date-picker
            v-model.trim="formData.protocolTime"
            :searchLabel="$t('page.content.Publish')"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="请选择"
            end-placeholder="请选择"
          ></el-date-picker> -->
          <el-select
            v-model="formData.purchaseType"
            clearable
            multiple
            collapse-tags
            :placeholder="$t('page.content.purchaseTypePlaceholder')"
            :searchLabel="$t('page.content.purchaseType')"
          >
            <el-option
              v-for="item in searchCondition[0].options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model.trim="formData.noticeTime"
            :searchLabel="$t('page.content.publishTime')"
            clearable
            type="daterange"
            :range-separator="$t('page.content.to')"
            :start-placeholder="$t('page.content.pleaseChoose')"
            :end-placeholder="$t('page.content.pleaseChoose')"
          ></el-date-picker>
          <!--<el-select
            v-model="formData.noticeTime"
            clearable
            @change="changeRecent"
            :placeholder="$t('page.content.publishTimePlaceholder')"
            :searchLabel="$t('page.content.publishTime')"
          >
            <el-option
              v-for="item in searchCondition[1].options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <!-- <el-select
            v-model="formData.matBigClasses"
            clearable
            multiple
            collapse-tags
            :placeholder="$t('page.content.materialClassifyPlaceholder')"
            :searchLabel="$t('page.content.materialClassify')"
          >
            <el-option
              v-for="item in searchCondition[3].options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </template>
        <el-input
          v-model.trim="formData.schemeCode"
          clearable
          :searchLabel="$t('page.content.schemeCode')"
          :placeholder="$t('page.content.schemeCodePlaceholder')"
          slot="searchItem0"
        ></el-input>
        <el-input
          v-model.trim="formData.schemeName"
          clearable
          :searchLabel="$t('page.content.schemeName')"
          :placeholder="$t('page.content.schemeNamePlaceholder')"
          slot="searchItem1"
        ></el-input>
        <el-input
          v-model.trim="formData.noticeTitle"
          clearable
          :searchLabel="$t('page.content.GGTitle')"
          :placeholder="$t('page.content.titlePlaceholder')"
          slot="searchItem4"
        ></el-input>
        <!-- <el-date-picker
          slot="searchItem2"
          v-model.trim="formData.protocolTime"
          :searchLabel="$t('page.content.Publish')"
          clearable
          type="daterange"
          range-separator="至"
          start-placeholder="请选择"
          end-placeholder="请选择"
        ></el-date-picker> -->
        <el-select
          slot="searchItem2"
          v-model="formData.purchaseType"
          clearable
          multiple
          collapse-tags
          :placeholder="$t('page.content.purchaseTypePlaceholder')"
          :searchLabel="$t('page.content.purchaseType')"
        >
          <el-option
            v-for="item in searchCondition[0].options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          slot="searchItem3"
          v-model.trim="formData.noticeTime"
          :searchLabel="$t('page.content.publishTime')"
          clearable
          type="daterange"
          :range-separator="$t('page.content.to')"
          :start-placeholder="$t('page.content.pleaseChoose')"
          :end-placeholder="$t('page.content.pleaseChoose')"
        ></el-date-picker>
        <!--<el-select
          slot="searchItem3"
          v-model="formData.noticeTime"
          clearable
          @change="changeRecent"
          :placeholder="$t('page.content.publishTimePlaceholder')"
          :searchLabel="$t('page.content.publishTime')"
        >
          <el-option
            v-for="item in searchCondition[1].options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>-->
        <!-- <el-select
          slot="searchItem4"
          v-model="formData.matBigClasses"
          clearable
          multiple
          collapse-tags
          :placeholder="$t('page.content.materialClassifyPlaceholder')"
          :searchLabel="$t('page.content.materialClassify')"
        >
          <el-option
            v-for="item in searchCondition[3].options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
      </el-search>
      <!--高级搜索End-->

      <!-- 内容 Begin -->
      <div class="notice-detail">
        <!-- <div class="notice-detail-list ccui-clearfix">
          <template v-for="(pItem, pIndex) in pageData">
            <div class="notice-detail-row" :key="pIndex">
              <template v-for="(item, index) in flist(pItem, colnum, null)">
                <div
                  v-if="item"
                  class="notice-detail-col notice-detail-box mb20"
                  :key="`${index}-${pIndex}`"
                >
                  <div class="notice-detail-box-out">
                    <notice-item-block
                      :type="'3'"
                      :data="item"
                    ></notice-item-block>
                  </div>
                  <div class="bottom-btn ccui-clearfix">
                    ( v-if="item.schemeStatus == 3" 暂时注释 进入项目时判断 )
                    <el-col :span="24" class="fl"
                      ><el-button
                        type="primary"
                        size="mini"
                        class="notice-btn"
                        style="border-rightsignUp: 1px solid rgba(255,255,255,0.26)"
                        @click="signUp(item)"
                        >{{ $t("page.content.enterProject") }}</el-button
                      ></el-col
                    >
                  </div>
                </div>
                <div
                  v-else
                  :key="`${index}-${pIndex}`"
                  style="width:220px"
                ></div>
              </template>
            </div>
          </template>
          <div v-if="isHaveData" class="noDataBox">
            <svg-icon iconClass="noData" class="no-data" />
            <p>{{ $t("page.content.noData") }}</p>
          </div>
        </div>-->
        <el-table
          :data="pageData"
          :fit="true"
          border
          class="dic-sub-table-style01"
          :empty-text="$t('page.content.noData')"
          maxHeight="2000"
        >
          <!-- 序号 -->
          <el-table-column
            type="index"
            :label="$t('page.content.No')"
            width="50"
            fixed
          ></el-table-column>
          <!-- 公告标题 -->
          <el-table-column
            prop="noticeTitle"
            :label="$t('page.content.GGTitle')"
            min-width="230"
            show-overflow-tooltip
            fixed
          >
          </el-table-column>
          <!-- 方案编号 -->
          <el-table-column
            prop="schemeCode"
            :label="$t('page.content.schemeCode')"
            min-width="230"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 方案名称 -->
          <el-table-column
            prop="schemeName"
            :label="$t('page.content.schemeName')"
            min-width="230"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 采购方式 -->
          <el-table-column
            prop="purchaseTypeName"
            :label="$t('page.content.purchaseType')"
            :min-width="languagezh_cn ? 120 : 180"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- 发布时间 -->
          <el-table-column
            prop="noticeStartTime"
            :label="$t('page.content.publishTime')"
            min-width="140"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span>
                {{ moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm") }}
              </span>
            </template>
          </el-table-column>
          <!-- 分包商名称 -->
          <el-table-column
            prop="supName"
            :label="$t('page.content.subcontractor')"
            min-width="260"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="$t('page.content.state')"
            prop="schemeStatusName"
            width="70"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.schemeStatusName == "执行中"
                  ? $t("page.content.performing")
                  : scope.row.schemeStatusName == "已完成"
                  ? $t("page.content.completed")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.content.op')"
            :width="languagezh_cn ? 70 : 120"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-button
                size="mini"
                type="text"
                @click.native.stop="signUp(row)"
                >{{ $t("page.content.carryOut") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 内容 End -->

      <!--分页Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <div class="ccui-table-footer" v-show="pageData.length > 0">
          <div class="ccui-operation">
            <slot name="batchOp"></slot>
          </div>

          <div id="ccui-paging">
            <el-pagination
              :total="pageTotal"
              :page-size="pageSize"
              :current-page="pageNo"
              :page-sizes="pageSizeOption"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleSizeChange('none')"
              >{{ $t("page.content.sure1") }}</el-button
            >
          </div>
        </div>
      </div>
      <!--分页End-->
    </div>
  </div>
</template>

<script>
import {
  searchSupBidNoticeNew,
  // qryMatcateryTreeList,
  getSupInfoByLoginInfo
  //listDictByCode
} from "@/app/myProjects/api/myProjects.js";
import { getSubcontractInfoByLoginInfoNew } from "@/app/myProjects/api/myProjectsEl.js";
// import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
// import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import moment from "moment";
export default {
  name: "myProjectSub",
  // mixins: [mixinHomePage],
  components: {
    // noticeItemBlock
    // baseBreadCrumb
  },
  data() {
    return {
      formData: {
        schemeCode: "",
        schemeName: "",
        noticeTitle: "",
        purchaseType: [],
        noticeTime: [],
        matBigClasses: ""
      },
      tableTopBtn: [
        { label: this.$t("page.content.performing"), value: "1" },
        { label: this.$t("page.content.completed"), value: "2" }
      ], //全部
      isFocus: "1",
      projectStatus: "1", //执行状态
      searchCondition: [
        {
          type: this.$t("page.content.purchaseType"),
          typeValue: "1",
          selectedValue: "",
          isMultiSelect: false,
          isMore: false,
          options: [
            // { label: "全部", value: "", isActive: true },
            {
              label: this.$t("page.content.purchaseTypeValue1"),
              // label: "公开招标",
              value: "0",
              isActive: false
            },
            {
              label: this.$t("page.content.purchaseTypeValue4"),
              // label: "邀请招标",
              value: "3",
              isActive: false
            },
            {
              label: this.$t("page.content.purchaseTypeValue12"),
              // label: "谈判-邀请",
              value: "4",
              isActive: false
            },
            // {
            // label: this.$t("page.content.purchaseTypeValue4"),
            // label: "单一来源",
            //   value: "2",
            //   isActive: false
            // },
            {
              label: this.$t("page.content.purchaseTypeValue11"),
              // label: "询比-邀请",
              value: "1",
              isActive: false
            },
            {
              label: this.$t("page.content.purchaseTypeValue10"),
              // label: "询比-公开",
              value: "7",
              isActive: false
            },
            {
              label: this.$t("page.content.purchaseTypeValue9"),
              // label: "谈判-公开",
              value: "8",
              isActive: false
            }
          ]
        },
        {
          type: this.$t("page.content.publishTime"),
          typeValue: "2",
          selectedValue: "",
          options: [
            // { label: "全部", value: "", isActive: true },
            {
              label: this.$t("page.content.publishTimeValue1"),
              value: "3",
              isActive: false
            },
            {
              label: this.$t("page.content.publishTimeValue2"),
              value: "7",
              isActive: false
            },
            {
              label: this.$t("page.content.publishTimeValue3"),
              value: "30",
              isActive: false
            }
          ]
        },
        {
          type: this.$t("page.content.projectStatus"),
          typeValue: "4",
          selectedValue: "",
          options: [
            {
              label: this.$t("page.content.performing"),
              value: "",
              isActive: true
            },
            {
              label: this.$t("page.content.completed"),
              value: "3",
              isActive: false
            }
          ]
        }
        // {
        //   type: "物资分类",
        //   typeValue: "3",
        //   selectedValue: "",
        //   isMultiSelect: false,
        //   isMore: false,
        //   options: [
        //     // { label: "全部", value: "", isActive: true }
        //   ]
        // }
      ],
      matBigClassesOptions: [],
      pageData: [],
      agentIdEncrypt: "",
      pageNo: 1,
      pageSize: 10,
      pageSizeOption: [10, 20, 50, 100, 200, 500],
      colnum: 5,
      pageTotal: 0, //总条数
      total: 0, //总页数
      purchaseType: [], //采购方式
      noticeTime: [], //发布时间
      matBigClasses: "", //物资分类
      sortOrder: 0, //排序
      supInfo: {}, //物采供应商信息
      subcontractorInfo: {}, //分包商信息
      isHaveData: false,
      subcontractorCode: "", //分包商code
      supCode: "", //供应商code
      //purchaseTypeArr: [],
      moment
    };
  },
  activated() {
    // this.init();
    this.isHaveData = false;
  },
  created() {},
  mounted() {
    this.supInfo = JSON.parse(sessionStorage.getItem("supInfo"));
    this.supCode = sessionStorage.getItem("supCode");
    this.subcontractorCode = sessionStorage.getItem("subcontractorCode");
    this.subcontractorInfo =
      JSON.parse(sessionStorage.getItem("subcontractorInfo")) ||
      this.$store.state.app.subcontractorInfo;

    // if (
    //   this.supInfo.supCode == "" ||
    //   this.supInfo.supCode == "0" ||
    //   this.supCode == "" ||
    //   this.supCode == "0"
    // ) {
    //   this.searchCondition[0].options = [
    //     // { label: "全部", value: "", isActive: true },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue1"),
    //       label: "公开招标",
    //       value: "1",
    //       isActive: false
    //     },

    //     {
    //       //label: this.$t("page.content.purchaseTypeValue3"),
    //       label: "竞争性谈判",
    //       value: "3",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue4"),
    //       label: "邀请招标",
    //       value: "4",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue5"),
    //       label: "邀请竞价",
    //       value: "5",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue7"),
    //       label: "公开询价",
    //       value: "7",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue8"),
    //       label: "公开竞价",
    //       value: "8",
    //       isActive: false
    //     }
    //   ];
    // } else if (
    //   this.subcontractorCode !== "" &&
    //   this.subcontractorCode !== "0" &&
    //   this.subcontractorCode !== null
    // ) {
    //   this.searchCondition[0].options = [
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue1"),
    //       label: "公开招标",
    //       value: "1",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue2"),
    //       label: "询价采购",
    //       value: "2",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue3"),
    //       label: "竞争性谈判",
    //       value: "3",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue4"),
    //       label: "邀请招标",
    //       value: "4",
    //       isActive: false
    //     },
    //     {
    //       //label: this.$t("page.content.purchaseTypeValue5"),
    //       label: "邀请竞价",
    //       value: "5",
    //       isActive: false
    //     }
    //   ];
    // }
    this.init();
    //this.getPurchaseType();
    // this.getSupCode();
    // this.getMatcateryTreeList();
  },
  methods: {
    tableTopChange(item) {
      this.pageTotal = 0;
      this.isFocus = item.value;
      this.projectStatus = item.value;
      this.formData = {
        schemeName: "",
        noticeTitle: "",
        purchaseType: [],
        noticeTime: [],
        matBigClasses: ""
      };
      this.noticeTime = [];
      this.search();
    },
    // 搜索
    search() {
      this.pageNo = 1;
      this.init();
    },
    // 执行
    signUp(row) {
      console.log("row", row);
      this.$store.commit("editRouterName", this.$t("page.menuList.MyProjects"));
      sessionStorage.setItem("purchaseType", row.purchaseType);

      sessionStorage.setItem("schemeId", row.schemeId);
      // if (row.supplierFlag + "" === "1") {
      sessionStorage.setItem("subcontractorCode", row.supCode);
      sessionStorage.setItem("subcontractorName", row.supName);
      sessionStorage.setItem("supplierFlag", 1);
      this.$router.push({
        name: "bidFlowIndexSub",
        query: {
          type: "myProject",
          schemeId: row.schemeId,
          // schemeObj: JSON.stringify(row),
          noticeStartTime: row.noticeStartTime,
          noticeEndTime: row.noticeEndTime,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          supCode: row.supCode,
          supName: row.supName,
          supplierFlag: 1
        }
      });
      // } else if (row.supplierFlag + "" === "0") {
      //   sessionStorage.setItem("supCode", row.supCode);
      //   sessionStorage.setItem("supName", row.supName);
      //   sessionStorage.setItem("supplierFlag", row.supplierFlag);
      //   this.$router.push({
      //     name: "bidFlowIndex",
      //     query: {
      //       type: "myProject",
      //       schemeId: row.schemeId,
      //       // schemeObj: JSON.stringify(row),
      //       noticeStartTime: row.noticeStartTime,
      //       noticeEndTime: row.noticeEndTime,
      //       schemeName: row.schemeName,
      //       schemeCode: row.schemeCode,
      //       supCode: row.supCode,
      //       supName: row.supName,
      //       supplierFlag: row.supplierFlag
      //     }
      //   });
      // }
    },
    getSupCode() {
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      getSupInfoByLoginInfo({
        loginId: loginId,
        agentId: this.$router.history.current.query.a
      }).then(res => {
        if (res) {
          this.supInfo = res.data.data;
          sessionStorage.setItem("supCode", res.data.data.supCode);
          sessionStorage.setItem("supInfo", JSON.stringify(res.data.data));
          let type = 0; //1物采供应商，2分包商，3同时
          if (res.data.data.supCode == "" || res.data.data.supCode == "0") {
            type = 2;
          } else {
            type = 1;
          }
          this.getSupInfoByLoginInfoSubBox(type);
        }
      });
    },
    getSupInfoByLoginInfoSubBox(type) {
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      getSubcontractInfoByLoginInfoNew({
        loginId: loginId,
        agentId: this.$router.history.current.query.a
      }).then(res => {
        if (res) {
          this.subcontractorInfo = res.data.data;
          sessionStorage.setItem("subcontractorCode", res.data.data.supCode);
          sessionStorage.setItem(
            "subcontractorInfo",
            JSON.stringify(res.data.data)
          );
          this.init();
          // if (type == 2) {
          // this.searchCondition[0].options = [
          //   // { label: "全部", value: "", isActive: true },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue1"),
          //     value: "1",
          //     isActive: false
          //   },

          //   {
          //     label: this.$t("page.content.purchaseTypeValue3"),
          //     value: "3",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue4"),
          //     value: "4",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue7"),
          //     value: "7",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue8"),
          //     value: "8",
          //     isActive: false
          //   }
          // ];
          // } else if (
          //   type == 1 &&
          //   res.data.data.supCode !== "" &&
          //   res.data.data.supCode !== "0" &&
          //   res.data.data.supCode !== null
          // ) {
          // this.searchCondition[0].options = [
          //   {
          //     label: this.$t("page.content.purchaseTypeValue1"),
          //     value: "1",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue2"),
          //     value: "2",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue3"),
          //     value: "3",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue4"),
          //     value: "4",
          //     isActive: false
          //   },
          //   {
          //     label: this.$t("page.content.purchaseTypeValue5"),
          //     value: "5",
          //     isActive: false
          //   }
          // ];
          // }
        }
      });
    },
    // getPurchaseType() {
    //   listDictByCode({ code: "SCHEME_PURCHASE_TYPE" }).then(res => {
    //     this.purchaseTypeArr = res.data.data.filter(
    //       e => e.dicValue !== "其他采购"
    //     );
    //   });
    // },
    init() {
      // let supCodeList = [];
      // let subcontractorCodeList = [];
      // if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
      //   supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
      //     return item.supCode;
      //   });
      // }
      // if (this.subcontractorInfo.getSupInfoByLoginInfoRspBOList) {
      //   subcontractorCodeList = this.subcontractorInfo.getSupInfoByLoginInfoRspBOList.map(
      //     item => {
      //       return item.supCode;
      //     }
      //   );
      // }
      // let mainWidth = 1680;
      // if (window.innerWidth > 1720) {
      //   mainWidth = 1680;
      // } else if (window.innerWidth < 1120) {
      //   mainWidth = 1080;
      // } else {
      //   mainWidth = window.innerWidth - 57;
      // }
      // if (mainWidth % 220 === 0) {
      //   this.colnum = Math.floor(mainWidth / 220) - 1;
      // } else {
      //   this.colnum = Math.floor(mainWidth / 220);
      // }
      // if (this.pageSize === 0) {
      //   this.pageSize = this.colnum * 2;
      // }
      // this.pageSizeOption = [
      //   this.colnum * 2,
      //   this.colnum * 4,
      //   this.colnum * 10,
      //   this.colnum * 20,
      //   this.colnum * 40,
      //   this.colnum * 100
      // ];
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        tabId: "1",
        schemeName: this.formData.schemeName,
        noticeTitle: this.formData.noticeTitle,
        schemeCode: this.formData.schemeCode,
        isShowPageLoading: true,
        sortName: "1",
        projectStatus: this.projectStatus,
        joinedOrNotJoin: true,
        sortOrder: this.sortOrder,
        // supCodeList: supCodeList || (this.supInfo &&
        //   this.supInfo.supCode + "" == "" &&
        //   this.subcontractorInfo.getSupInfoByLoginInfoRspBOList.length > 1
        //     ? [this.subcontractorCode]
        //     : subcontractorCodeList),
        supCode: this.subcontractorCode || this.subcontractorInfo.supCode,
        matBigClasses: this.formData.matBigClasses
      };

      // params.searchSupBidNoticeListReqBO = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   schemeName: this.formData.schemeName,
      //   noticeTitle: this.formData.noticeTitle,
      //   schemeCode: this.formData.schemeCode,
      //   isShowPageLoading: true,
      //   sortName: "1",
      //   projectStatus: this.projectStatus,
      //   joinedOrNotJoin: true,
      //   sortOrder: this.sortOrder,
      //   supCodeList:
      //     this.supInfo &&
      //     this.supInfo.supCode + "" == "" &&
      //     this.subcontractorInfo.getSupInfoByLoginInfoRspBOList.length > 1
      //       ? [this.subcontractorCode]
      //       : subcontractorCodeList,
      //   supCode: this.subcontractorCode,
      //   matBigClasses: this.formData.matBigClasses
      // };

      params.purchaseType = this.formData.purchaseType; //采购方式是
      if (this.formData.noticeTime && this.formData.noticeTime[0]) {
        //发布时间
        params.noticeTimeStart = moment(this.formData.noticeTime[0]).format(
          "YYYY-MM-DD"
        );
        params.noticeTimeEnd = moment(this.formData.noticeTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      searchSupBidNoticeNew(params).then(res => {
        if (res.data.code === "0") {
          this.agentIdEncrypt = res.data.data.agentIdEncrypt;
          this.pageData = [];
          if (res.data.data.rows.length == 0) {
            this.isHaveData = true;
          } else {
            this.isHaveData = false;
          }
          this.pageData = res.data.data.rows;
          // for (var i = 0; i < res.data.data.rows.length; i += this.colnum) {
          //   this.pageData.push(res.data.data.rows.slice(i, i + this.colnum));
          // }

          this.pageTotal = res.data.data.recordsTotal;
          this.total = res.data.data.total;
        }
      });
    },
    flist(arr, n, str) {
      // 补齐数组
      for (var i = arr.length; i < n; i++) {
        arr.push(str);
      }
      return arr;
    },
    // getMatcateryTreeList() {
    //   //查询物资分类
    //   qryMatcateryTreeList({
    //     parentMatcateryCode: "00"
    //   }).then(res => {
    //     if (res.data.code === "0") {
    //       res.data.data.map(item => {
    //         this.matBigClassesOptions.push({
    //           label: item.matcateryName,
    //           value: item.matcateryCode
    //         });
    //         this.searchCondition[3].options = JSON.parse(
    //           JSON.stringify(this.matBigClassesOptions)
    //         );
    //       });
    //     }
    //   });
    // },

    changeRecent(value) {
      let endTime = "";
      let startTime = "";
      if (value !== "") {
        endTime = moment(new Date()).format("YYYY-MM-DD");
        startTime = moment(
          new Date().getTime() - Number(value) * 1000 * 24 * 60 * 60
        ).format("YYYY-MM-DD");
      }
      this.noticeTime = [startTime, endTime];
    },
    getList(obj) {
      this.getSupCode();
    },
    handlePrev() {
      --this.pageNo;
    },
    handleNext() {
      ++this.pageNo;
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      if (val !== "none") {
        this.pageSize = val;
      }
      this.init();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.init();
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .languageen_us {
  .el-searchs-bottom {
    border-top: none;
    .el-searchs-bottom-form {
      .el-form-item__label {
        min-width: 165px !important;
      }
      .el-input__inner {
        padding-right: 10px;
        // width: 305px;
      }
      .el-form-item__content {
        .el-select {
          // width: 305px;
        }
      }
    }
  }
}
.wrapperM20 {
  margin-top: -20px;
}
/deep/ .ccui-app-container-detail {
  padding-top: 0;
}
// /deep/ .el-button.el-button--table-top-active {
//   border: none;
// }
.search-condition {
  background-color: #fff;
  // margin-top: 15px;
  margin-bottom: 20px;
}
.condition {
  min-height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
}
.condition-left {
  min-width: 108px;
}
.condition-type {
  color: #666666;
  font-size: 13px;
  cursor: text;
}
.condition-type1 {
  color: #666666;
  font-size: 13px;
}
/deep/ .ccui-multifunctional-table-wrapper .ccui-table-footer {
  padding-top: 0;
  padding-bottom: 20px;
}
.condition /deep/ .el-button {
  margin-right: 30px;
  margin-left: 0;
}
.condition em {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 8px;
}
.activeBlack {
  color: #999999;
}
.active {
  color: #0089ef;
}
.el-icon-caret-bottom {
  margin-top: -5px;
}
.dis-flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.page-em {
  padding-right: 20px;
  padding-left: 10px;
  font-size: 14px;
}
.hiddenHeight {
  height: 50px;
  overflow: hidden;
}
.more-and-more {
  margin-right: 20px;
  font-size: 13px;
  color: #4a4a4a;
}
.chooseActive {
  .button-show {
    border: 1px solid #0089ef;
    position: relative;
    width: 135px;
    color: #0089ef;
    display: inline-block;
    text-align: left;
    padding-left: 12px;
    margin-right: 0;
  }
  b {
    background-color: #0089ef;
    color: #ffffff;
    width: 30px;
    display: inline-block;
    line-height: 34px;
    text-align: center;
    margin-right: 10px;
    padding-top: 1px;
  }
}
/deep/ .is-disabled {
  color: #cccccc;
}
.notice-warning-outline {
  font-size: 14px;
  vertical-align: super;
}
/deep/ .is-disabled {
  color: #fff;
}
.mrDiv {
  height: 20px;
  width: 100%;
  background-color: #f1f1f1;
}
.noDataBox {
  background: #f2f2f2;
  width: 240px;
  height: 310px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #cccccc;
  .no-data {
    width: 88px;
    height: 76px;
  }
  p {
    font-size: 18px;
    color: #999999;
    margin-top: 20px;
    font-family: PingFangSC-Semibold, sans-serif;
  }
}
// .searchInput {
//   height: 50px;
//   border-left: 1px solid #f1f1f1;
//   margin-left: 15px;
//   padding-left: 15px;
//   display: flex;
//   align-items: center;
//   /deep/.el-input-group__append {
//     padding: 0px;
//   }
//   /deep/.el-input__inner {
//     border-right: none !important;
//   }
//   /deep/.el-input__inner:focus {
//     border-right: none !important;
//     border-top: 1px solid #ccc !important;
//     border-left: 1px solid #ccc !important;
//     border-bottom: 1px solid #ccc !important;
//   }

// /deep/ .el-input-group__append button.el-button {
//   margin-right: 0px;
//   background-color: #fff !important;
//   border: none;
//   height: 28px;
//   border-radius: 0px 4px 4px 0px;
// }
// }
</style>
